module.exports = __webpack_public_path__ + "static/img/acquiesce_icon.96403b25.png";